import { Button, Icon, Text, VStack } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the navigation button
 * 
 * @param {Object} props The props of the component
 * @returns The navigation button
 */
const NavigationButton = ({ children, icon, isSelected, title, ...props }) => (
  <Button
    padding={0}
    variant={"navigation"}
    {...props}
  >
    <VStack whiteSpace={"normal"}>
      {icon && <Icon as={icon} boxSize={"40px"} />}
      {title && <Text fontWeight={400} fontSize={"12px"} wordBreak={"keep-all"} color={"white"}>{title}</Text>}
    </VStack>
    {children}
  </Button>
);

export default React.memo(NavigationButton);
